import React from 'react';
import UploadMultiDocuments from '@components/UploadMultiDocuments';
import UploadedFileTable from '@components/UploadedFileTable';
import { FileListData } from '@typings/ResidentTypes';

interface UploadRespectFormDocumentProps {
  userId: string;
  uploadedRespectFormFileList: FileListData[];
  setUploadedRespectFormFileList: React.Dispatch<
    React.SetStateAction<FileListData[]>
  >;
  isUploadEnabled: boolean;
}

const UploadRespectFormDocument: React.FC<UploadRespectFormDocumentProps> = ({
  userId,
  uploadedRespectFormFileList,
  setUploadedRespectFormFileList,
  isUploadEnabled,
}) => {
  return (
    <div className="govuk-form-group mt-10 govuk-bp:mt-14">
      <p className="govuk-body">
        If a ReSPECT form has been completed it can be uploaded below.
      </p>

      {isUploadEnabled ? (
        <UploadMultiDocuments
          userId={userId}
          fileList={uploadedRespectFormFileList}
          setFileList={setUploadedRespectFormFileList}
          uploadInputId="upload-respect-form"
          customizedButtonText="Upload ReSPECT "
        />
      ) : (
        <button
          type="button"
          className="govuk-button govuk-button--secondary govuk-!-margin-bottom-0"
          disabled
        >
          Upload ReSPECT
        </button>
      )}

      <div className="mt-10 govuk-bp:mt-14">
        {uploadedRespectFormFileList?.length > 0 && (
          <UploadedFileTable
            headerTitle="ReSPECT Form File Name"
            fileList={uploadedRespectFormFileList}
            setFileList={setUploadedRespectFormFileList}
          />
        )}
      </div>
    </div>
  );
};

export default UploadRespectFormDocument;
